import { Module } from 'vuex';
import {
  action,
  actionCreatorFactory,
  combineAction,
  combineMutation,
  mutation,
} from 'vuex-typescript-fsa/lib';
import { RootState } from '@/store';
import {
  CvSectionGallery,
  CvSectionGalleryResponse,
  UpdateCvSectionGalleryRequest,
} from '@/../gen';

export const namespace = 'cvSectionGalleryEdit';
const actionCreator = actionCreatorFactory(namespace);

export const GetCvSectionGallery = actionCreator<{
  params: {
    cv_id: number;
    id: number;
  };
}>('GET_CV_SECTION_GALLERY');
export const SetCvSectionGallery = actionCreator<CvSectionGalleryResponse>(
  'SET_CV_SECTION_GALLERY'
);
export const UpdateCvSectionGallery = actionCreator<{
  params: {
    cv_id: number;
    id: number;
  };
  body: UpdateCvSectionGalleryRequest;
}>('UPDATE_CV_SECTION_GALLERY');
export const DeleteCvSectionGallery = actionCreator<{
  params: {
    cv_id: number;
    id: number;
  };
}>('DELETE_CV_SECTION_GALLERY');
export const ResetState = actionCreator<null>('RESET_STATE');

export interface State {
  cvSectionGallery: CvSectionGallery;
}

const initialState = (): State => {
  return { cvSectionGallery: null };
};

export const module: Module<State, RootState> = {
  namespaced: true,
  state: initialState,
  actions: combineAction(
    action(GetCvSectionGallery, async function(context, action) {
      const { data } = await this.proffApi.getCvSectionGallery(
        action.payload.params.cv_id,
        action.payload.params.id
      );
      context.commit(SetCvSectionGallery(data.data));
    }),
    action(UpdateCvSectionGallery, async function(context, action) {
      const { data } = await this.proffApi.updateCvSectionGallery(
        action.payload.params.cv_id,
        action.payload.params.id,
        action.payload.body
      );
      context.commit(SetCvSectionGallery(data.data));
    }),
    action(DeleteCvSectionGallery, async function(context, action) {
      await this.proffApi.deleteCvSectionGallery(
        action.payload.params.cv_id,
        action.payload.params.id
      );
      context.commit(SetCvSectionGallery(null));
    }),
    action(ResetState, function(context, action) {
      context.commit(ResetState(action.payload));
    })
  ),
  mutations: combineMutation(
    mutation(SetCvSectionGallery, (state, action) => {
      state.cvSectionGallery = action.payload?.attributes;
    }),
    mutation(ResetState, state => {
      Object.assign(state, initialState());
    })
  ),
  getters: {
    cvSectionGallery: state => state.cvSectionGallery,
  },
};
